<!-- Floating Action Button -->
<button 
  class="widget-fab"
  mat-fab
  color="primary"
  (click)="toggle()"
  [attr.aria-label]="isOpen ? 'Fechar tutoriais' : 'Abrir tutoriais'"
  [title]="isOpen ? 'Fechar tutoriais' : 'Ver tutoriais em vídeo'">
  <mat-icon>{{ isOpen ? 'close' : 'live_help' }}</mat-icon>
</button>

<!-- Floating Widget Panel -->
<div 
  class="widget-panel"
  [@slidePanel]="isOpen ? 'open' : 'closed'"
  *ngIf="isOpen">
  
  <!-- Widget Header -->
  <div class="widget-header">
    <div class="header-title">
      <mat-icon>video_library</mat-icon>
      <span>Central de Suporte</span>
    </div>
    <button mat-icon-button (click)="close()" title="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Widget Content -->
  <div class="widget-content">
    
    <!-- Search Bar -->
    <div class="search-section">
      <mat-form-field class="search-field" appearance="outline">
        <mat-label>Buscar tutoriais</mat-label>
        <input 
          matInput 
          [formControl]="searchControl"
          placeholder="Digite para buscar..."
          type="text">
        <mat-icon matPrefix>search</mat-icon>
        <button 
          mat-icon-button 
          matSuffix 
          *ngIf="searchControl.value"
          (click)="clearFilters()"
          title="Limpar busca">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-hint *ngIf="!loading">
          <span *ngIf="filteredVideos.length > 0">
            {{ filteredVideos.length }} vídeo{{ filteredVideos.length !== 1 ? 's' : '' }} encontrado{{ filteredVideos.length !== 1 ? 's' : '' }}
          </span>
          <span *ngIf="filteredVideos.length === 0" class="no-results-hint">
            Nenhum vídeo encontrado
          </span>
        </mat-hint>
      </mat-form-field>

      <!-- Context Filter Badge -->
      <div class="context-filter-badge" *ngIf="autoDetectedCategory && !loading">
        <mat-icon>filter_alt</mat-icon>
        <span>Mostrando vídeos de: <strong>{{ categoryLabels[autoDetectedCategory] }}</strong></span>
        <button mat-icon-button (click)="showAllVideos()" title="Ver todos os vídeos" class="show-all-btn">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Carregando vídeos...</p>
    </div>

    <!-- Videos List (Grouped by Category) -->
    <div class="videos-list" *ngIf="!loading">
      <mat-accordion multi="true">
        <mat-expansion-panel 
          *ngFor="let group of groupedVideos" 
          [expanded]="true"
          class="category-panel-compact">
          
          <!-- Category Header -->
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="category-icon">folder</mat-icon>
              <span class="category-name">{{ group.category.label }}</span>
              <span class="video-count">({{ group.videos.length }})</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- Videos in Category -->
          <div class="videos-in-category">
            <div 
              *ngFor="let video of getVisibleVideos(group.category.key, group.videos); trackBy: trackByVideoId" 
              class="video-item-compact"
              (click)="openVideoDialog(video)">
              
              <!-- Thumbnail -->
              <div class="video-thumbnail-compact">
                <img 
                  [src]="getVimeoThumbnailUrl(video.vimeoId)"
                  [alt]="video.title">
                <div class="play-overlay-compact">
                  <mat-icon>play_arrow</mat-icon>
                </div>
              </div>

              <!-- Info -->
              <div class="video-info-compact">
                <div class="video-title-compact">{{ video.title }}</div>
                <div class="video-keywords-compact" *ngIf="video.keywords && video.keywords.length > 0">
                  <mat-icon>label</mat-icon>
                  <span>{{ video.keywords.slice(0, 2).join(', ') }}</span>
                  <span *ngIf="video.keywords.length > 2">+{{ video.keywords.length - 2 }}</span>
                </div>
              </div>
            </div>

            <!-- Show More Button -->
            <button 
              *ngIf="hasMoreVideos(group.category.key, group.videos.length)"
              class="show-more-btn"
              mat-stroked-button
              color="primary"
              (click)="toggleCategoryExpansion(group.category.key); $event.stopPropagation()">
              <mat-icon>expand_more</mat-icon>
              Ver mais {{ getHiddenVideosCount(group.videos.length) }} vídeo{{ getHiddenVideosCount(group.videos.length) !== 1 ? 's' : '' }}
            </button>

            <!-- Show Less Button -->
            <button 
              *ngIf="isCategoryExpanded(group.category.key) && group.videos.length > INITIAL_VIDEOS_PER_CATEGORY"
              class="show-more-btn"
              mat-stroked-button
              color="primary"
              (click)="toggleCategoryExpansion(group.category.key); $event.stopPropagation()">
              <mat-icon>expand_less</mat-icon>
              Ver menos
            </button>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Empty State -->
      <div class="empty-state-compact" *ngIf="groupedVideos.length === 0">
        <mat-icon>video_library</mat-icon>
        <p>Nenhum vídeo encontrado</p>
        <button mat-stroked-button color="primary" (click)="clearFilters()">
          Limpar filtros
        </button>
      </div>
    </div>

  </div>
</div>
